"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAttributeSelector = exports.useAttributeMapSelector = exports.useAttributeIconSelector = exports.useSpecialtiesSelector = exports.useMedicationsAvailableSelector = void 0;

var _attributeIds = _interopRequireDefault(require("@devsontap/nica-api/core/utils/attributeIds"));

var _index = require("../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// /**
//  * Returns the data necessary to render the attribute list
//  */
// export const useAttributeListSelector = () => {
//     return useShallowEqualSelector(({ attributes }) => {
//         const attributeList = attributes.attributeIds ? attributes.attributeIds.map(id => attributes.attributeMap[id]) : null;
//         return {
//             ...(_.pick(attributes, ["loading", "attributeIds", "error"])),
//             attributeList
//         };
//     });
// };
//
// export const useAttributeInflatorSelector = () => {
//     return useShallowEqualSelector(({ attributes }) => {
//         return (attributes.attributeIds && attributes.attributeIds.map(id => attributes.attributeMap[id])) || [];
//     });
// }
//
// /**
//  * Return a single Attribute record
//  * @param attributeId    id of the attribute to return
//  */
// export const useAttributeSelector = (attributeId) => {
//     return useShallowEqualSelector(({ attributes }) => {
//         return attributes.attributeMap[attributeId] ? attributes.attributeMap[attributeId] : null;
//     });
// };
var useMedicationsAvailableSelector = function useMedicationsAvailableSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref) {
    var attributeMap = _ref.attributes.attributeMap;

    if (attributeMap[_attributeIds.default.medicationsAvailable]) {
      var groups = attributeMap[_attributeIds.default.medicationsAvailable].groups;
      return Object.keys(groups).map(function (groupId) {
        var options = groups[groupId].options; // return Object.keys(options).map(optionId => ({ id: optionId, name: options[optionId].name }))

        return Object.keys(options).map(function (optionId) {
          return {
            key: optionId,
            groupKey: groupId,
            option: groups[groupId].options[optionId]
          };
        });
      }).reduce(function (result, groupOptions) {
        return [].concat(_toConsumableArray(result), _toConsumableArray(groupOptions));
      }, []).sort(function (item1, item2) {
        return item1.option.name.localeCompare(item2.option.name);
      });
    }

    return null;
  });
};

exports.useMedicationsAvailableSelector = useMedicationsAvailableSelector;

var useSpecialtiesSelector = function useSpecialtiesSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref2) {
    var attributeMap = _ref2.attributes.attributeMap;

    if (attributeMap[_attributeIds.default.practiceSpecialty]) {
      var options = attributeMap[_attributeIds.default.practiceSpecialty].options;
      return Object.keys(options) // .map(optionId => ({ id: optionId, name: options[optionId].name }))
      .map(function (optionKey) {
        return {
          key: optionKey,
          option: options[optionKey]
        };
      }).sort(function (item1, item2) {
        return item1.option.name.localeCompare(item2.option.name);
      });
    }

    return null;
  });
};

exports.useSpecialtiesSelector = useSpecialtiesSelector;

var useAttributeIconSelector = function useAttributeIconSelector(attributeId) {
  return (0, _index.useShallowEqualSelector)(function (_ref3) {
    var attributeMap = _ref3.attributes.attributeMap;
    return attributeMap && attributeMap[attributeId] ? attributeMap[attributeId].icon : "";
  });
};

exports.useAttributeIconSelector = useAttributeIconSelector;

var useAttributeMapSelector = function useAttributeMapSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref4) {
    var attributeMap = _ref4.attributes.attributeMap;
    return attributeMap;
  });
};
/**
 * Return a single Location record
 * @param attributeId    id of the attribute to return
 */


exports.useAttributeMapSelector = useAttributeMapSelector;

var useAttributeSelector = function useAttributeSelector(attributeId) {
  return (0, _index.useShallowEqualSelector)(function (_ref5) {
    var attributes = _ref5.attributes;
    return attributes.attributeMap[attributeId] ? attributes.attributeMap[attributeId] : null;
  });
};

exports.useAttributeSelector = useAttributeSelector;